import { Theme } from '@mui/material';

export const ANNOTATION_TAG = 'annotation';

export const STATUS_PENDING = 'pending';
export const STATUS_DRAFT = 'draft';

export const EDITABLE_TASK_STATUSES = [STATUS_PENDING, STATUS_DRAFT];

export const STATUS_CHIP_BACKGROUND_MAPPING = (theme: Theme) => {
  return {
    finalized: theme.palette.success.main,
    pending: theme.palette.primary.main,
    draft: theme.palette.grey[500],
    complete: theme.palette.success.main,
  };
};

export const STATUS_CHIP_TEXT_COLOR_MAPPING = (theme: Theme) => {
  return {
    finalized: theme.palette.success.contrastText,
    pending: theme.palette.primary.contrastText,
    draft: theme.palette.primary.contrastText,
    complete: theme.palette.success.contrastText,
  };
};

export const ANNOTATION_STATUS_CREATED = 'created';
export const ANNOTATION_STATUS_UPDATED = 'updated';
export const ANNOTATION_STATUS_REJECTED = 'rejected';
export const ANNOTATION_STATUS_ACCEPTED = 'accepted';
export const ANNOTATION_STATUS_DELETED = 'deleted';
export const ANNOTATION_STATUS_ADDED_BY_SUPERVISOR = 'addedBySupervisor';
export const ANNOTATION_STATUS_BOTH_ANNOTATORS = 'bothAnnotators';
